import * as React from 'react';
import { observable, action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Panel, ListGroup, ListGroupItem, Glyphicon, Button, Col, Row, FormControl } from 'react-bootstrap';
import { IAuftragDetailsResponse, IDienstleistung, IDienstleistungsListeResponse } from '../../models/ApiTypes';
import { bind, inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { UiStore } from '../../stores/UiStore';
import FilterBox from '../site/FilterBox';

interface IAuftragDienstleistungAnlegenProps {
  auftragId: string;
  auftragKategorie: string;
  onAddDienstleistung?: (dienstleistung: string) => void;
}

class ListFilter {
  @observable filter: string;
  @observable dienstleistungen?: Array<{
    dienstleistung: IDienstleistung;
    benutzt: boolean;
    einmalig: boolean;
    zeigebezeichnung: boolean;
  }>;

  @action set(dienstleistungen: IDienstleistungsListeResponse, auftragDetails: IAuftragDetailsResponse) {
    this.dienstleistungen = [];
    for (let dienstleistung of dienstleistungen) {
      // Gültige Dienstleistungen sollen nur einmal aufgelistet werden, auch wenn diese mehrfach über unterschiedliche Befugnisse für den angemeldeten Benutzer freigeschaltet
      if (!dienstleistung.gueltig || this.dienstleistungen.some((d) => d.dienstleistung.kuerzel_dienstleistung === dienstleistung.kuerzel_dienstleistung)) {
        continue;
      }
      this.dienstleistungen.push({
        dienstleistung: dienstleistung,
        benutzt: auftragDetails.dienstleistungen.some((ad) => ad.kuerzel_dienstleistung.toLowerCase() === dienstleistung.kuerzel_dienstleistung.toLowerCase()),
        // Bestimmte Vorgänge wie z.B. Dienstleistungsnachweise dürfen nur einmal im Auftrag eingefügt werden
        einmalig: dienstleistung.kuerzel_dienstleistung.toLocaleLowerCase().indexOf('dienstleistungsnachweis') > -1,
        // Bezeichnungen (als Beschreibung) anzeigen wenn ungleich Kürzel
        zeigebezeichnung: dienstleistung.bezeichnung !== dienstleistung.kuerzel_befugnis
      });
    }
  }

  @computed get filtered() {
    if (this.filter) {
      return this.dienstleistungen ? this.dienstleistungen.filter(el => el.dienstleistung.kuerzel_dienstleistung.toLocaleLowerCase().includes(this.filter)) : [];
    } else {
      return this.dienstleistungen;
    }
  }

  @action setFilter(filter: string) {
    this.filter = filter.toLocaleLowerCase();
  }
}

@observer
export default class AuftragDienstleistungAnlegen extends React.Component<IAuftragDienstleistungAnlegenProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  dienstleistungsliste: ListFilter = new ListFilter();

  async componentDidMount() {
    let dienstleistungen = await this.apiStore.dienstleistungen(this.props.auftragKategorie);
    let auftragDetails = await this.apiStore.auftragDetails(this.props.auftragId);
    if (dienstleistungen.ok && auftragDetails.ok) {
      this.dienstleistungsliste.set(dienstleistungen.json, auftragDetails.json);
    }
  }

  @bind @action handleFilterList(event: React.FormEvent<FormControl>) {
    let filterText = (event.target as HTMLInputElement).value;
    this.dienstleistungsliste.setFilter(filterText);
  }

  render() {
    const { onAddDienstleistung } = this.props;
    return (
      <div className="maxwidth">
        <h2>Neue Dienstleistung hinzufügen</h2>
        <FilterBox onChange={this.handleFilterList}/>
        <Panel
          header="Verfügbare Dienstleistungen"
          footer={(
            <div className="text-right">
              <Button onClick={() => this.uiStore.navigateBack()}>Abbrechen</Button>
            </div>
          )}
        >
          <ListGroup fill={true}>
            {!this.dienstleistungsliste.filtered ? (
              <ListGroupItem>Lade Dienstleistungen...</ListGroupItem>
            ) : (this.dienstleistungsliste.filtered.length === 0) ? (
              <ListGroupItem>Es sind keine Dienstleistungen für diesen Auftragstyp verfügbar</ListGroupItem>
            ) : this.dienstleistungsliste.filtered.map((dienstleistung, index) => (
              <ListGroupItem
                key={index}
                className={(dienstleistung.benutzt && dienstleistung.dienstleistung.kuerzel_dienstleistung.toLocaleLowerCase().indexOf('dienstleistungsnachweis') > -1) ? 'dienstleistung-benutzt' : 'dienstleistung-neu'}
              >
                <Row>
                  <Col xs={10} sm={11} md={11}>
                    {dienstleistung.dienstleistung.kuerzel_dienstleistung}
                    {dienstleistung.zeigebezeichnung && <div><small>{dienstleistung.dienstleistung.bezeichnung}</small></div>}
                    {dienstleistung.benutzt && dienstleistung.einmalig &&
                      <div><small>Kann nur einmal eingefügt werden, und wird im Auftrag bereits verwendet.</small></div>
                    }
                  </Col>
                  <Col xs={2} sm={1} md={1}>
                    {onAddDienstleistung && (!dienstleistung.benutzt || !dienstleistung.einmalig) && (
                      <Button
                        className="btn-flat btn-success pull-right"
                        title="Dienstleistung hinzufügen"
                        onClick={() => onAddDienstleistung(dienstleistung.dienstleistung.kuerzel_dienstleistung)}
                      >
                        <Glyphicon glyph="plus"/>
                      </Button>
                    )}
                  </Col>
                </Row>
              </ListGroupItem>
            ))}
          </ListGroup>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/AuftragDienstleistungAnlegen.tsx